export const PLAN_TYPES = {
    BASIC: 'basic',
    DELUXE: 'deluxe'
};